/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Standards_Preset_Delete_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete the preset \"{name}\"? This cannot be undone." |
*
* @param {Standards_Preset_Delete_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_delete_confirm_text = /** @type {((inputs: Standards_Preset_Delete_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Delete_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the preset "${i?.name}"? This cannot be undone.`)
});